import { render, staticRenderFns } from "./plan-simple.vue?vue&type=template&id=79656850&"
import script from "./plan-simple.vue?vue&type=script&lang=js&"
export * from "./plan-simple.vue?vue&type=script&lang=js&"
import style0 from "./plan-simple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports